  document.addEventListener('change', function (e) {
  if (e.target && e.target.matches('.options-selection__option-value-input')) {
    // let selection apply, then drop focus so no ring remains
    setTimeout(function(){ e.target.blur(); }, 0);
  }
});
// Extra safety for iOS tap behavior
document.addEventListener('touchend', function (e) {
  const el = e.target.closest('.options-selection__option-value-input');
  if (el) setTimeout(function(){ el.blur(); }, 0);
}, { passive: true });